import React, {FunctionComponentElement, useEffect, useState} from "react";
import {NodeInputProps} from "./index";
import {AutoComplete, AutoCompleteChangeEvent} from "primereact/autocomplete";
import { DataPortModel } from "../../pages/editor/diagram/ports/DataPortModel";
import { useGraph } from "../../hooks/useGraph";

interface Input{ id:string, name:string, sourceNodeId: string, port: DataPortModel, fields: { name: string }[], values: { name: string }[] }

let reg = new RegExp(/(.*)\[(.*)\]/)
export const Input = (props: NodeInputProps): FunctionComponentElement<NodeInputProps> => {
    const [inputs, setInputs] = useState<Input[]>([])
    const {activeNode} = useGraph()
    const [suggestions, setSuggestions] = useState<{ name: string }[]>([])

    useEffect(()=>{
        let m = props.type.match(reg)
        if (m) {
            if (m[2]){
                let inputNames = m[2].split(';') || []
                let inputs: Input[] = []

                // console.log('coinput (node=', activeNode, ') (input=',inputNames, ')')
                if(!activeNode){
                    return
                }

                activeNode?.getInPorts().forEach((inp)=>{

                    if (inp.getDefinition === undefined){
                        console.error('invalid port model (inp=undefined) for node=',activeNode?.getName())
                        return
                    }
                    const portDef = inp.getDefinition()
                    if (!portDef){
                        console.error('invalid port model (definition=undefined) for node=',activeNode?.getName())
                        return
                    }

                    const inputPos = inputNames.indexOf(portDef.id)
                    if(inputPos > -1){
                        // console.log('in port:', inp.getName(), 'def:', portDef, 'link:', inp.getLinks())
                        const links = Object.keys(inp.getLinks())
                        if(links){

                            links.find((linkName) =>{
                                const link = inp.getLinks()[linkName];
                                const port = link.getSourcePort() as DataPortModel
                                const def = port.getDefinition()
                                if (!def){
                                    console.error('failed to find port definition. (port=',port, 'link=',linkName,')')
                                    return
                                }

                                const fields = def.fields? def.fields.map(f => ({name: f})) : []
                                const propValue = props.value?.find((p:{id: string, fields: string}) => p.id === port.getNode().getID())
                                let tmpValues: string =  propValue ? propValue.fields : undefined
                                let values: {name: string}[] = tmpValues? tmpValues.split(',').map(v => ({name: v})): []
                                inputs.push({id: port.getNode().getID(), name: def.name, port: port, sourceNodeId: port.getNode().getName() || "-", fields: fields, values: values})
                            })

                        }
                    }
                })

                setInputs(inputs)
            }
        }

    }, [props.type, props.value])


    const handleMultiSelectClick = (e:AutoCompleteChangeEvent, input: Input)=>{
        const newValues = inputs.map(i => {
            let fields = input.id === i.id ? e.value.map((v: any) => v.name).join(','): i.values.map((v: any) => v.name).join(',')
            return {id: i.id, fields}
        });
        props.onChange(newValues)
    }

    const searchCountry = (event: { query: string }, input: Input) => {
        // console.log('search, ', event.query, input.fields)

        setTimeout(() => {
            let _filtered: { name: string }[];
            if (!event.query.trim().length) {
                _filtered = [...input.fields];
            }
            else {
                _filtered = input.fields.filter((inp) => {
                    return inp.name.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }
            // console.log('filtered:', _filtered.push({name: event.query}))
            setSuggestions(_filtered);
        }, 250);
    }


    return <div className={"flex flex-column"}>
        {inputs.length > 0 && inputs.map(input => {
            return <div key={input.sourceNodeId+input.id}>
                <label>{input.sourceNodeId} ({input.id})</label>
                {/*<MultiSelect optionLabel="name" value={input.values} options={input.fields} onChange={(e)=>handleMultiSelectClick(e, input)} />*/}
                <AutoComplete value={input.values}  suggestions={suggestions} completeMethod={(e)=>searchCountry(e, input)} multiple field="name"  onChange={(e) => handleMultiSelectClick(e, input)} />


            </div>
        })}
        {inputs.length === 0 && <p>Connecter les sources pour modifier ce paramètre</p>}
    </div>
}